import styled from 'styled-components';

export const Container = styled.footer`
    grid-area: footer;
    background-color: #ddd;
    color: #333;

    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10px;
`;
